export const forumAttachmentMimeTypes = ['image/jpeg', 'image/png', 'image/gif', 'application/pdf', 'text/plain'];
export const forumAttachmentMaxSizeInBytes = 10 * 1024 * 1024;
// The BFF refuses a new chat whose attachments together exceed this.
export const forumNewChatAttachmentsMaxTotalSizeInBytes = 20_000_000;
